import httpClient from "./httpClient"; // Adjust the path if needed

const TeamsService = {
  async findAll(page = 1, pageSize = 100) {
    return await httpClient.get("/team", {
      params: { page, pageSize }
    });
  },

  async create(entity) {
    return await httpClient.post("/team", entity);
  },

  async update(entity) {
    return await httpClient.put(`/team/${entity.id}`, entity);
  },

  async archive(id) {
    return await httpClient.get("/team/archive", {
      params: {
        id,
        archived_by: localStorage.getItem("id")
      }
    });
  }
};

export default TeamsService;
